import { render, staticRenderFns } from "./productTechnology.vue?vue&type=template&id=3fd17541&"
import script from "./productTechnology.vue?vue&type=script&lang=js&"
export * from "./productTechnology.vue?vue&type=script&lang=js&"
import style0 from "./productTechnology.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports